import { render, staticRenderFns } from "./ClinicPaymentMethodSetup.vue?vue&type=template&id=24a81daa&scoped=true&"
import script from "./ClinicPaymentMethodSetup.vue?vue&type=script&lang=js&"
export * from "./ClinicPaymentMethodSetup.vue?vue&type=script&lang=js&"
import style0 from "./ClinicPaymentMethodSetup.vue?vue&type=style&index=0&id=24a81daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a81daa",
  null
  
)

export default component.exports